import { createAsyncThunk } from "@reduxjs/toolkit";
import getAxios from "../helpers/axiosInterceptor";
import { API_ROUTES_PATHS } from "../utils/constant";

// Method to get DIS.PRICING API
export const getDisbursementPrice = createAsyncThunk(
  "disbursement/getDisbursement",
  async (thunkApi) => {
    try {
      let res = await getAxios().get(API_ROUTES_PATHS.GET_DISBURSEMENT_PRICE);

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Method to update Disbursement Price
export const updateDisbursementPrice = createAsyncThunk(
  "disbursement/updateDisbursement",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().patch(
        `${API_ROUTES_PATHS.UPDATE_DISBURSEMENT_PRICE}`,
        model,
        {
          params: model?.query,
        }
      );

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Method to create Internal Disbursement
export const createInternalDisbursement = createAsyncThunk(
  "internalDisbursement/createInternalDisbursement",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().post(
        `${API_ROUTES_PATHS.CREATE_INTERNAL_DISBURSEMENT}`,
        model
      );

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Method to get Internal Disbursement API
export const getInternalDisbursement = createAsyncThunk(
  "internalDisbursement/getInternalDisbursement",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().get(
        API_ROUTES_PATHS.CREATE_INTERNAL_DISBURSEMENT,
        {
          params: model?.query,
        }
      );
      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Method to get Internal Disbursement by id api
export const getInternalDisbursementById = createAsyncThunk(
  "internalDisbursement/getInternalDisbursementById",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().get(
        `${API_ROUTES_PATHS.CREATE_INTERNAL_DISBURSEMENT}/${model?.id}`,
        
      );
      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Method to update Internal Disbursement
export const updateInternalDisbursement = createAsyncThunk(
  "internalDisbursement/updateInternalDisbursement",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().patch(
        `${API_ROUTES_PATHS.CREATE_INTERNAL_DISBURSEMENT}/${model?.id}`,
        model
      );

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Method to delete Internal Disbursement
export const deleteInternalDisbursement = createAsyncThunk(
  "internalDisbursement/deleteInternalDisbursement",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().delete(
        `${API_ROUTES_PATHS.CREATE_INTERNAL_DISBURSEMENT}/${model?.id}`
      );

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);
